import React from 'react';
import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import { ClientPrioritiesResponse } from 'model/client.model';

const ContactStatusBox = ({
  contractStatus,
}: {
  contractStatus: ClientPrioritiesResponse['contractStatus'];
}) => (
  <Box
    sx={{
      backgroundColor: zeplinColor.Neutral2,
      border: `1px solid ${zeplinColor.Neutral5}`,
      borderRadius: '14px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    }}
  >
    <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
      Contact Status
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '14px',
          color: zeplinColor.BasicBlack,
          whiteSpace: 'nowrap',
        }}
      >
        Expires in {contractStatus?.expiryFormatted ?? 'N/A'}
      </Typography>
      <Box
        sx={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: zeplinColor.Neutral8,
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '14px',
          color: zeplinColor.Success,
          whiteSpace: 'nowrap',
        }}
      >
        {contractStatus?.monthsRemaining ?? 'N/A'} months
      </Typography>
    </Box>
  </Box>
);

export default ContactStatusBox;
